import { gql } from '../../types/generated';

export const GET_PLAYBACK_OVERRIDES = gql(`
  query playbackOverrides {
    playbackOverrides {
      id
      experience
      features
      matchParams
    }
  }
`);
